module.exports = __webpack_public_path__ + "static/media/2 (6).1faa4880.jpg";